exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contextmenu[data-v-113a23ce] {\n  position: fixed;\n  z-index: 1;\n  border: 1px solid #9e9e9e;\n  border-radius: 4px;\n  -webkit-box-shadow: 2px 2px 10px #aaaaaa !important;\n          box-shadow: 2px 2px 10px #aaaaaa !important;\n}\n", ""]);

// exports
